import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { findingRenderMethod_LabelMap, findingRenderMethods } from '@app/advisor-ui-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const mandatoryProps_FindingRenderMethod = {
    adapter: SimpleListAdapter([...findingRenderMethods], item => _jsx(_Fragment, { children: findingRenderMethod_LabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Finding Render Method',
};
export const DropDown_FindingRenderMethod = TS_DropDown.prepare(mandatoryProps_FindingRenderMethod);
//# sourceMappingURL=ui-components.js.map